import { render, staticRenderFns } from "./DeveloperEmailForm.vue?vue&type=template&id=52a06f42"
import script from "./DeveloperEmailForm.vue?vue&type=script&lang=js"
export * from "./DeveloperEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports